"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFinmoTimeRangeForTimeline = resolveFinmoTimeRangeForTimeline;
exports.resolveFinmoTimeRangeForDateRange = resolveFinmoTimeRangeForDateRange;
exports.resolveWalletExportFetchStep = resolveWalletExportFetchStep;
const wallet_export_constants_js_1 = require("./wallet-export.constants.js");
function resolveFinmoTimeRangeForTimeline(timeline) {
    if (!timeline || timeline === "all") {
        return {};
    }
    const match = /^(\d{4})-(\d{2})$/.exec(timeline.trim());
    if (!match) {
        return {};
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    if (month < 1 || month > 12) {
        return {};
    }
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 0, 23, 59, 59, 999);
    return {
        start_time: Math.floor(start.getTime() / 1000),
        end_time: Math.floor(end.getTime() / 1000),
    };
}
/** Converts an optional ISO date/datetime range into the Finmo `start_time`/`end_time` unix-second params. An invalid or absent bound is simply omitted (left open-ended). */
function resolveFinmoTimeRangeForDateRange(startDate, endDate) {
    const range = {};
    if (startDate) {
        const start = new Date(startDate);
        if (!Number.isNaN(start.getTime())) {
            range.start_time = Math.floor(start.getTime() / 1000);
        }
    }
    if (endDate) {
        const end = new Date(endDate);
        if (!Number.isNaN(end.getTime())) {
            // A date-only string (e.g. "2026-09-13") parses to midnight UTC — extend it to the end of that day so
            // same-day activity isn't excluded by the inclusive upper bound.
            const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(endDate.trim());
            if (isDateOnly) {
                end.setUTCHours(23, 59, 59, 999);
            }
            range.end_time = Math.floor(end.getTime() / 1000);
        }
    }
    return range;
}
/**
 * Pagination stop / truncation rules for wallet PDF export Finmo fetch.
 * Truncation is only reported for "all time" exports.
 */
function resolveWalletExportFetchStep(input) {
    const maxRows = input.maxRows ?? wallet_export_constants_js_1.WALLET_EXPORT_MAX_ROWS;
    const isAllTime = !input.timeline || input.timeline === "all";
    const nextTotal = input.rowsSoFar + input.pageRowCount;
    if (nextTotal >= maxRows) {
        return { stop: true, truncated: isAllTime, rowCap: maxRows };
    }
    if (!input.pageRowCount || input.pageRowCount < input.pageSize) {
        return { stop: true, truncated: false };
    }
    if (input.page + 1 > input.maxPages) {
        return { stop: true, truncated: isAllTime };
    }
    return { stop: false, truncated: false };
}
